import { Box, Button, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function ProductSearchBar({ value, onChange, disabled }) {
  const handleClear = () => onChange("");

  return (
    <Box sx={{ flex: "1 1 240px", minWidth: 0 }}>
      <TextField
        fullWidth
        label="Search products"
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder="Name, article code, category, barcode…"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#666" }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <Button
                size="small"
                onClick={handleClear}
                sx={{ minWidth: "auto", color: "#666" }}
              >
                Clear
              </Button>
            </InputAdornment>
          ) : null,
        }}
      />
    </Box>
  );
}
